import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Modal,
  SxProps,
  Typography,
  Box,
  useTheme
} from '@mui/material';
import { Button } from 'system/atoms';

type Props = {
  columns: string[];
  csvData: string[][];
  handleClose: () => void;
  isOpen: boolean;
  title?: string;
  subTitle?: string;
};

const modalContainer: SxProps = {
  display: 'flex',
  padding: 6,
  justifyContent: 'center',
  alignItems: 'center'
};

const container: SxProps = {
  p: 4,
  backgroundColor: 'background.default',
  borderRadius: 2
};

const CsvPreviewTable: React.FC<Props> = ({
  columns,
  csvData,
  handleClose,
  isOpen,
  title,
  subTitle
}) => {
  const {
    palette: { info }
  } = useTheme();

  return (
    <Modal open={isOpen} sx={modalContainer} onClose={handleClose}>
      <Box sx={container}>
        <Typography fontWeight="600">{title}</Typography>
        <Typography variant="subtitle1">{subTitle}</Typography>
        <Box sx={{ p: 3 }}>
          <TableContainer
            sx={{ backgroundColor: 'background.default', height: 400 }}
          >
            <Table aria-label="simple table">
              <TableHead sx={{ backgroundColor: info.main }}>
                <TableRow>
                  {columns.map((column, index) => (
                    <TableCell
                      key={`column-${column}-${index}`}
                      sx={{ fontWeight: 'bold' }}
                    >
                      {column}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {csvData.map((row, index) => {
                  if (!row.length) return null;

                  return (
                    <TableRow key={`table-row-${row[index]}-${index}`}>
                      {row.map((item, j) => (
                        <TableCell key={`table-cell-${item}-${j}`}>
                          {item}
                        </TableCell>
                      ))}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Button onClick={handleClose} variant="primary" fullWidth>
          Done
        </Button>
      </Box>
    </Modal>
  );
};

export { CsvPreviewTable };
